export const space = {
    space10: "4px",
    space20: "8px",
    space30: "12px",
    space40: "16px",
    space50: "24px",
    space60: "32px",
    space70: "48px",
} as const;
